import { $t } from "@/lib/helpers/i18nHelper";
import currencyLib from "currency-codes";
import { listToDropdownList } from "@/lib/helpers/listHelpers";

export const CREDITS_CURRENCY_CODE = "CRE";

interface IFormatMoneyOptions {
  currencyCode?: string;
  withSymbol?: boolean;
  withSign?: boolean;
  useGrouping?: boolean;
}

// tslint:disable:unified-signatures
export function formatMoney(amount: string | number, currencyCode?: string): string;
export function formatMoney(amount: string | number, options?: IFormatMoneyOptions): string;
// tslint:enable:unified-signatures
export function formatMoney(
  amount: string | number,
  arg: string | IFormatMoneyOptions = CREDITS_CURRENCY_CODE
): string {
  const parsedAmount = Math.abs(parseFloat(amount.toString()));
  let currencyCode: string;
  let withSymbol = true;
  let withSign = false;
  let useGrouping = false;
  if (typeof arg === "string") {
    currencyCode = arg;
  } else {
    ({ currencyCode = CREDITS_CURRENCY_CODE, withSymbol = true, withSign = false, useGrouping = false } = arg);
  }

  if (currencyCode === CREDITS_CURRENCY_CODE || currencyCode === "") {
    const symbol = withSymbol ? ` ${$t("Cr")}` : "";
    const sign = withSign && amount > 0 ? "+" : amount < 0 ? "−" : "";
    return [
      sign,
      Intl.NumberFormat("en", {
        style: "decimal",
        useGrouping,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(parsedAmount),
      symbol,
    ].join("");
  }

  return Intl.NumberFormat("en", { style: "currency", currency: currencyCode.toUpperCase(), useGrouping })
    .formatToParts(parsedAmount)
    .reduce(
      (out, item) => {
        if ((!withSymbol && item.type === "currency") || item.type === "literal") {
          return out;
        }
        return out + item.value;
      },
      withSign && amount > 0 ? "+" : amount < 0 ? "−" : ""
    );
}

export function getCurrencySymbol(currencyCode: string): string {
  if (currencyCode.toUpperCase() === CREDITS_CURRENCY_CODE) return $t("Cr");
  const currency = Intl.NumberFormat("en", {
    style: "currency",
    currency: currencyCode.toUpperCase(),
  })
    .formatToParts(0)
    .find(item => item.type === "currency");
  return (currency && currency.value) || "";
}

export function getPrimaryCurrencyAmount(amount: number) {
  return amount;
}

// eslint-disable-next-line no-unused-vars
export function convertMoney(amount: number, to: string, from: string = CREDITS_CURRENCY_CODE) {
  return amount;
}

export const currencyList = listToDropdownList(currencyLib.codes());
